import Page from "../../../components/Page";
// import { useRouter } from "next/router";
import YouTubeEmbed from "../../../components/YoutubeEmbed";

import { useParams } from "react-router-dom";

// const lessons: Lessons = {
//     "1": {
//         name: "Lesson 1",
//         description: "This is lesson 1",
//         video: "e_cFkV4ymsSg",
//         file: "",
//         id: "1",
//     },
// };

const LessonPage = () => {
    // const router = // useRouter();
    // const id: string = (router.query.id || "1").toString();
    // const id: string = "1";

    const params = useParams();
    const id: string = (params.id || 1) as string;

    const lessonExists = true; // lessons[id] !== undefined;

    if (lessonExists) {
        return (
            <>
                <head>
                    <title>Math with Maki</title>
                    <meta name="description" content="Math with Maki" />
                    <link rel="icon" href="/favicon.ico" />
                </head>
                <Page href="math150">
                    {/* <h1>{lessons[id].name}</h1> */}
                    <br></br>
                    {/* <p>{lessons[id].description}</p> */}
                    <br></br>
                    {/* <YouTubeEmbed videoId={lessons[id].video} /> */}
                </Page>
            </>
        );
    } else {
        return (
            <>
                <head>
                    <title>Math with Maki</title>
                    <meta name="description" content="Math with Maki" />
                    <link rel="icon" href="/favicon.ico" />
                </head>
                <Page href="math150">
                    <h1>Lesson not found</h1>
                </Page>
            </>
        );
    }
};

export default LessonPage;
